<div class="life-lead-container">
    <div class="life-lead-banner">
        <owl-carousel-o class="web-slider" [options]="customOptions">
            <ng-template carouselSlide><img src="assets/images/life-lead-banner-1.jpg" class="img-fluid sliderClass" (click)="leadFormRedirection()"></ng-template>
            <ng-template carouselSlide><img src="assets/images/life-lead-banner-2.jpg" class="img-fluid sliderClass" (click)="leadFormRedirection()"></ng-template>
        </owl-carousel-o>
    </div>
</div>